"use client";

import React, { useCallback, useMemo } from "react";
import {
  EventResponse,
  eventResponseStatusSchema
} from "@vereinsheim/backend-types/src/event";
import { Person } from "@/sources/kicker-amateur/types";
import { EventCardActions } from "@/app/pwa/components/event/EventCard/EventCardActions";
import { useSession } from "next-auth/react";
import { useUserPersons } from "@/app/pwa/lib/pwa-context";
import PersonImage from "../../PersonImage";
import { EventWrapper } from "@/app/pwa/(main-layout)/events/lib/types";
import { isRegularEventWrapper } from "@/app/pwa/(main-layout)/events/lib/helper";
import { PersonFunction } from "@/app/api/auth/[...nextauth]/lib/authOptions";


export function useEventPersons(eventWrapper:EventWrapper, userPersonFunctions:PersonFunction[], userPersons:Person[]){
  const teamIds = useMemo(() => {
    return isRegularEventWrapper(eventWrapper) ? (eventWrapper.event.teamIds || []) : [eventWrapper.teamId]
  }, [eventWrapper])
  const memberIds = useMemo(() => {
    return isRegularEventWrapper(eventWrapper) ? (eventWrapper.event.memberIds || []) : undefined;
  }, [eventWrapper]);
  return useMemo(() => {
      const availablePersonIds: number[] = [];
      if (isRegularEventWrapper(eventWrapper) && eventWrapper.event.isClubEvent) {
        userPersonFunctions.forEach(p => {
          if (p.personId) {
            availablePersonIds.push(p.personId!);
          }
        });
      } else {
        userPersonFunctions.forEach(userPersonFunction => {
          if (userPersonFunction.personId && ((userPersonFunction.organizationType === "Team" && teamIds?.includes(`${userPersonFunction.organizationId}`) || memberIds?.includes(userPersonFunction.personId.toString())))) {
            availablePersonIds.push(userPersonFunction.personId);
          }
        });
      }
      return userPersons.filter(p => availablePersonIds.includes(p.Id!));
    },
    [eventWrapper, userPersons, userPersonFunctions, teamIds, memberIds]
  );
}
interface EventCardAttendancePickerProps {
  eventWrapper: EventWrapper;
  onResponseChange?: (response: EventResponse) => void;
  showAttendees?: boolean;
}

export function EventCardAttendancePicker({
                                            eventWrapper,
                                            onResponseChange,
                                            showAttendees
                                          }: EventCardAttendancePickerProps) {
  let responses = eventWrapper.event.responses;
  const calculateResponseTypes = useCallback(() => {
    const responseTypes = {
      [eventResponseStatusSchema.enum.accepted]: { title: "Zusagen", title_one: "Zusage", number: 0 },
      [eventResponseStatusSchema.enum.maybe]: { title: "Unsicher", title_one: "Unsicher", number: 0 },
      [eventResponseStatusSchema.enum.declined]: { title: "Absagen", title_one: "Absage", number: 0 }
    };
    Object.entries(responses).forEach(([_, responseType]) => {
      if (responseType != "noSelection") {
        responseTypes[responseType].number += 1;
      }
    });
    return Object.values(responseTypes).filter(r => r.number).map(r => {
      if (r.number == 1) {
        return `${r.number} ${r.title_one}`;
      } else {
        return `${r.number} ${r.title}`;
      }
    }).join(", ");
  }, [responses]);

  const formattedResponseTypes = useMemo(() => calculateResponseTypes(), [calculateResponseTypes]);

  const { data: session } = useSession();
  const user = session?.user
  const userPersons = useUserPersons();
  const persons:Person[] = useEventPersons(eventWrapper,user?.personFunctions ?? [],userPersons)

  return (
    <>
      {persons.length > 0 &&
        <div>
          <div className="flex justify-between items-baseline px-3 border-t border-gray-150 pt-2.5">
            <span className="font-bold">Deine Teilnahme:</span>
            {showAttendees &&
              <span className="text-gray-200 text-sm">
            {formattedResponseTypes}
          </span>
            }
          </div>
          <div className="flex flex-col gap-2 mt-1.5">
            {persons.length > 1
              ?
              <>
                {persons.map(p =>
                  <div key={p.Id} className=" border border-gray-150 rounded-md">
                    <div className="flex justify-center pt-2 pb-2 items-center gap-x-2 bg-gray-100 rounded-t">
                      <div className="w-6 flex-shrink-0">
                        {/* <FunctionImage imageClassName="" player={p}
                                  functionId={p.Function?.find(func => p.OrganizationIds?.find(id => id === func.OrganizationId))?.Id}
                                  size="sm"/> */}
                        <PersonImage person={p} className="w-6" />
                      </div>
                      <span className="font-semibold ">{`${p.FirstName} ${p.LastName}`}</span>
                    </div>
                    <div className="p-0.5">
                      <EventCardActions
                        event={eventWrapper.event}
                        person={p}
                        onResponseChange={onResponseChange}
                        isMultiPerson={true}
                      />
                    </div>
                  </div>
                )}
              </>
              :
              <>
                {persons.map(p =>
                  <div key={p.Id} className="">
                    <EventCardActions
                      event={eventWrapper.event}
                      person={p}
                      onResponseChange={onResponseChange}
                    />
                  </div>
                )}
              </>
            }
          </div>
        </div>
      }
    </>
  );
}
